import React from "react";
import {
  Radio as MuiRadio,
  RadioProps as MuiRadioProps,
  Stack,
  FormControlLabel,
  Typography,
  Box,
} from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";
import { IconWithTooltip } from "common/tooltip";

export interface IRadioButtonProps extends MuiRadioProps {
  value: string;
  label: string;
  helperText?: string;
  tooltipTitle?: string;
  startIcon?: SvgIconComponent;
  "data-custom-css-value"?: string; // for form custom css
}
export const RadioButton: React.FC<IRadioButtonProps> = ({
  value,
  disabled,
  label,
  tooltipTitle,
  helperText,
  startIcon: Icon,
  "data-custom-css-value": dataCssValue,
  ...props
}) => {
  return (
    <FormControlLabel
      sx={{ alignItems: "flex-start" }}
      value={value}
      data-custom-css-value={dataCssValue}
      control={
        <MuiRadio
          size="small"
          disabled={disabled}
          inputProps={{ "aria-label": label.toLowerCase() }}
          {...props}
        />
      }
      label={
        <Stack direction="column" sx={{ pt: 1 }}>
          <Stack direction="row" alignItems="flex-start" gap={0.5}>
            {Icon && (
              <Box>
                <Icon sx={{ fontSize: 16 }} />
              </Box>
            )}
            <Typography
              color={disabled ? "text.disabled" : "text.primary"}
              variant="body2"
              sx={{ display: "inline", whiteSpace: "pre-line" }}
            >
              {label}
              {tooltipTitle && (
                <IconWithTooltip
                  tooltipText={tooltipTitle}
                  variant="info"
                  iconSx={{ verticalAlign: "middle", ml: 0.5, pb: 0.3 }}
                />
              )}
            </Typography>
          </Stack>
          {helperText && (
            <Typography
              color={disabled ? "text.disabled" : "text.secondary"}
              variant="caption"
            >
              {helperText}
            </Typography>
          )}
        </Stack>
      }
    />
  );
};
